<template>
  <div @mouseenter="visibilityChange($event)">
    <Tooltip placement="top" :content="tooltipContent" :disabled="!tooltipVisible">
      <span class="tooltip-wrap">
        <slot>
          <span ref="textRef" :class="className" class="text">{{ text }}</span>
        </slot>
      </span>
    </Tooltip>
  </div>
</template>
<script>
export default {
  name: 'EllipsisTooltip',
  props: {
    text: { type: String, default: '' },
    content: { type: String, default: '' },
    placement: { type: String, default: 'top' },
    className: { type: String, default: 'text' },
  },
  data() {
    return {
      tooltipVisible: false,
    }
  },
  computed: {
    tooltipContent() {
      return !this.content ? this.text : this.content
    },
  },
  methods: {
    visibilityChange(event) {
      const ev = event.target
      const containerHeight = ev.offsetHeight
      const textHeight = this.$refs.textRef.offsetHeight
      this.tooltipVisible = textHeight && containerHeight < textHeight
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-wrap {
  display: inline-block;
  display: -webkit-box;
  line-height: inherit;
  word-break: break-all;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  white-space: nowrap;
}
span.text {
  white-space: initial;
}
</style>
<style lang="scss">
.tooltip-popper {
  max-width: 400px !important;
}
.ivu-tooltip-popper .ivu-tooltip-inner {
  white-space: break-spaces;
}
</style>
